import React from 'react';
import { User } from 'lucide-react';
import { GST_STATE_CODES } from '../../services/mathValidator';

interface Props {
  customerName: string;
  setCustomerName: (val: string) => void;
  customerGstin: string;
  setCustomerGstin: (val: string) => void;
  customerPhone: string;
  setCustomerPhone: (val: string) => void;
  customerEmail: string;
  setCustomerEmail: (val: string) => void;
  customerBillingAddress: string;
  setCustomerBillingAddress: (val: string) => void;
  placeOfSupply: string;
  setPlaceOfSupply: (val: string) => void;
  isInterState: boolean;
}

export const CustomerBillingSection: React.FC<Props> = ({
  customerName,
  setCustomerName,
  customerGstin,
  setCustomerGstin,
  customerPhone,
  setCustomerPhone,
  customerEmail,
  setCustomerEmail,
  customerBillingAddress,
  setCustomerBillingAddress,
  placeOfSupply,
  setPlaceOfSupply,
  isInterState
}) => {
  const handleGstinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.toUpperCase();
    setCustomerGstin(val);
    if (val.length >= 2) {
      const code = val.substring(0, 2);
      if (GST_STATE_CODES[code]) {
        setPlaceOfSupply(`${code}-${GST_STATE_CODES[code]}`);
      }
    }
  };

  return (
    <div className="rounded-2xl border border-white/10 bg-[#131316] p-5 space-y-4">
      <div className="flex items-center justify-between border-b border-white/5 pb-3">
        <div className="flex items-center gap-2 text-xs font-bold uppercase text-cyan-400">
          <User className="h-4 w-4" />
          <span>Customer & Billing Information</span>
        </div>
        <div className="text-[11px] text-slate-400">
          Place of Supply: <strong className="text-white">{placeOfSupply}</strong> ({isInterState ? 'Inter-State' : 'Intra-State'})
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
        <div>
          <label className="text-[11px] font-medium text-slate-300 block mb-1">
            Customer / Business Name *
          </label>
          <input
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            placeholder="e.g. Acme Innovations Pvt Ltd"
            className="w-full rounded-xl border border-white/10 bg-[#0e1015] px-3 py-2 text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500"
            required
          />
        </div>

        <div>
          <label className="text-[11px] font-medium text-slate-300 block mb-1">
            Customer GSTIN (Leave blank for B2C Retail)
          </label>
          <input
            type="text"
            value={customerGstin}
            onChange={handleGstinChange}
            placeholder="e.g. 27AABCA1234F1Z8"
            maxLength={15}
            className="w-full rounded-xl border border-white/10 bg-[#0e1015] px-3 py-2 text-white font-mono uppercase placeholder-slate-500 focus:outline-none focus:border-cyan-500"
          />
        </div>

        <div>
          <label className="text-[11px] font-medium text-slate-300 block mb-1">
            Customer Phone (for WhatsApp)
          </label>
          <input
            type="text"
            value={customerPhone}
            onChange={(e) => setCustomerPhone(e.target.value)}
            placeholder="e.g. 9820012345"
            className="w-full rounded-xl border border-white/10 bg-[#0e1015] px-3 py-2 text-white font-mono placeholder-slate-500 focus:outline-none focus:border-cyan-500"
          />
        </div>

        <div>
          <label className="text-[11px] font-medium text-slate-300 block mb-1">
            Customer Email
          </label>
          <input
            type="email"
            value={customerEmail}
            onChange={(e) => setCustomerEmail(e.target.value)}
            placeholder="accounts@customer.com"
            className="w-full rounded-xl border border-white/10 bg-[#0e1015] px-3 py-2 text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500"
          />
        </div>

        <div className="md:col-span-2">
          <label className="text-[11px] font-medium text-slate-300 block mb-1">
            Billing Address
          </label>
          <input
            type="text"
            value={customerBillingAddress}
            onChange={(e) => setCustomerBillingAddress(e.target.value)}
            placeholder="Premises, Street, City, Pincode"
            className="w-full rounded-xl border border-white/10 bg-[#0e1015] px-3 py-2 text-white placeholder-slate-500 focus:outline-none focus:border-cyan-500"
          />
        </div>
      </div>
    </div>
  );
};
